import React from 'react'
import { Link } from 'gatsby'
import searchIcon from '../../img/search.svg'
import styled from 'styled-components'

const SearchIcon = () => {
  return (
    <SearchIconWrapper>
      <Link to='/#search' style={{ position: 'relative' }}>
        <img src={searchIcon} alt='wishlist-icon' style={{ width: '25px', marginTop: '0.2rem', marginRight: '5rem' }} />
      </Link>
    </SearchIconWrapper>
  )
}

export default SearchIcon

const SearchIconWrapper = styled.span`
  position: absolute;
  top: 10px;
  right: 0;
  margin-right: 1rem;
`
